/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Consumption_Max_Series_TooltipInputs */



/**
* | output |
* | --- |
* | "Maximum {count} items displayed" |
*
* @param {Consumption_Max_Series_TooltipInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const consumption_max_series_tooltip = /** @type {((inputs: Consumption_Max_Series_TooltipInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumption_Max_Series_TooltipInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Maximum ${i?.count} items displayed`)
	return /** @type {LocalizedString} */ (`${i?.count} éléments affichés maximum`)
});